module.exports = __webpack_public_path__ + "img/icon-riser.89f95162.svg";